import React from "react";
import "./Styles/Styles.scss";

const RecommendFund = () => {};
export default RecommendFund;
